import { IBaseDocumentDto } from "../IBaseDocumentDto";

export enum AcquiringOperationType { 
    pay = 0,
    return = 1
}
export interface CreateAcquiringOperationsDto extends IBaseDocumentDto{
    baseDocumentAtId?:string;
    createdDate?:Date;
    operationType?:number;
    cashFlowItemId?:string;
    vatAmount?:number;
    vatType?:number;
    taxation?:number;
    amount?:number;
    vendorCustomerId?:number;
    companyId?:string;
    bankAcquirerId?:string;
    posTerminalId?:string;
    cashRegisterRetailId?:string
    accountId?:string;
    settlementAccountId?:string;
}
